export default __webpack_public_path__ + "static/media/Group 3715@2x.2e2dc373.png";